module.exports = __webpack_public_path__ + "static/media/video-power-searching.9f8c67d0.png";